<section class="centered-with-padding flex flex-col gap-y-3 py-7">
  @if (data.link; as link) {
    <div class="aspect-video overflow-hidden rounded-2xl">
      <app-youtube-player [videoId]="link | youtubeIdExtractor" />
    </div>
  }
  @if (data.legend; as legend) {
    <div class="font-bold">{{ legend }}</div>
  }
</section>
